const NOT_FOUND = {
  title: 'Ops...',
  subtitle: 'Parece que essa página não existe ou não está mais disponível',
  button: 'Voltar para página inicial',
}

export default NOT_FOUND
